import AboutUs20 from '@components/aboutUs/20'
import Image from '@components/Image'
import { ElementHTML } from '@helpers/helper.rendering'
import React, { useEffect, useRef, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const Services_4 = (props: RealEstateDataPageComponentData) => {
  const { items, opacityValue, titleElement, paragraphElement, height } = props
  const normalizedOpacity = Number(opacityValue) / 100

  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const itemRefs = useRef(items?.map(() => React.createRef<HTMLDivElement>()) ?? [])

  const scrollToItem = (index: number) => {
    if (typeof window === 'undefined') return

    const target = itemRefs.current[index].current
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }

  return (
    isMounted && (
      <>
        <div
          className="services-4 w-100 d-flex "
          style={{ height: screen.width < 992 ? 'auto' : '100vh' }}
        >
          <Container
            className="w-100 d-flex"
            style={{ maxWidth: '100%' }}
          >
            <Row>
              {items?.map((item, index) => (
                <Col
                  key={index}
                  className="position-relative d-flex align-items-center justify-content-center px-0 hover-shadow"
                  xs={12}
                  md={Math.floor(12 / items.length)}
                  style={{
                    height: screen.width < 992 ? '70vh' : '100vh',
                  }}
                >
                  <div
                    className="position-absolute w-100 h-100"
                    style={{
                      opacity:
                        opacityValue && opacityValue !== '0'
                          ? Number(opacityValue) !== 100
                            ? normalizedOpacity
                            : 1
                          : 0.6,
                      backgroundColor: '#000',
                      zIndex: 1,
                    }}
                  />
                  <Image
                    className="h-100 w-100 no-border image-hover"
                    objectFit="cover"
                    alt={`banner-img-${index}`}
                    image={item.image_gatsby!}
                  />
                  <ElementHTML
                    children={item?.title ?? ''}
                    elementType={titleElement ?? 'h1'}
                    className={'position-absolute text-center text-hover'}
                    style={{ cursor: 'pointer', zIndex: 2 }}
                    onClick={() => scrollToItem(index)}
                  />
                </Col>
              ))}
            </Row>
          </Container>
        </div>
        {items?.map((item, index) => (
          <div
            ref={itemRefs.current[index]}
            key={index}
          >
            <AboutUs20
              {...props}
              key={index}
              image_gatsby={item.image_gatsby}
              title={item?.title ?? ''}
              paragraphs={item?.paragraphs ?? []}
              height={height}
              align={index % 2 === 0 ? 'left' : 'right'}
              paragraphElement={paragraphElement}
              opacityValue={opacityValue}
              titleElement={titleElement}
            />
          </div>
        ))}
      </>
    )
  )
}

export default Services_4
